<template>
  <div>
    <button class="wrapper-menu sidebarCollapse" aria-label="Main Menu">
      <svg width="40" height="40" viewBox="0 0 100 100">
        <path
          class="line line1"
          d="M 20,29.000046 H 80.000231 C 80.000231,29.000046 94.498839,28.817352 94.532987,66.711331 94.543142,77.980673 90.966081,81.670246 85.259173,81.668997 79.552261,81.667751 75.000211,74.999942 75.000211,74.999942 L 25.000021,25.000058"
        ></path>
        <path class="line line2" d="M 20,50 H 80"></path>
        <path
          class="line line3"
          d="M 20,70.999954 H 80.000231 C 80.000231,70.999954 94.498839,71.182648 94.532987,33.288669 94.543142,22.019327 90.966081,18.329754 85.259173,18.331003 79.552261,18.332249 75.000211,25.000058 75.000211,25.000058 L 25.000021,74.999942"
        ></path>
      </svg>
    </button>
    <div class="navbarmain" id="header_menu">
      <div class="logo" @click="gotoRoute('/')">
        <img src="/static/img/logo/main_logo_20221004223046.png" />
      </div>
      <div class="menuicon">
        <ul class="animate__animated animate__slideInDown">
          <li>
            <a href="javascript:void(0)" @click="gotoRoute('/')">
              <img src="/static/img/landing/icon-12.png9" />
              <span>หน้าหลัก</span>
            </a>
          </li>
          <li>
            <a v-bind:href="`https://line.me/R/ti/p/${getLineId}`" target="_blank">
              <img src="/static/img/landing/icon-13.png" />
              <span>ติดต่อเรา</span>
            </a>
          </li>
        </ul>
        <div class="overlaymenu"></div>
      </div>
      <div class="loginregishead">
        <button
          class="btn btn-primary mt-lg-3 mr-lg-3"
          data-toggle="modal"
          data-target="#login"
        >
          <div class="-text-container">
            <a class="loginbtn" href="javascript:void(0)">เข้าสู่ระบบ</a>
          </div>
        </button>
        <button
          class="btn btn-primary mt-lg-3 mr-lg-3"
          data-toggle="modal"
          data-target="#register"
        >
          <div class="-text-container">
            <a class="registerbtn" href="javascript:void(0)">สมัครสมาชิก</a>
          </div>
        </button>
      </div>
    </div>

    <div class="x-button-actions" id="account-actions-mobile">
      <div class="-outer-wrapper">
        <div class="-left-wrapper">
          <span class="-item-wrapper">
            <span class="-ic-img">
              <a
                class="loginbtn"
                href="javascript:void(0)"
                data-toggle="modal"
                data-target="#login"
              >
                <span class="-textfooter d-block">
                  เข้าสู่ระบบ
                </span>
                <img
                  width="150"
                  height="150"
                  src="/static/img/landing/icon-17.png"
                />
              </a>
            </span>
          </span>
          <span class="-item-wrapper">
            <span class="-ic-img">
              <a
                class="registerbtn"
                href="javascript:void(0)"
                data-toggle="modal"
                data-target="#register"
              >
                <span class="-textfooter d-block">
                  สมัคร
                </span>
                <img
                  width="50"
                  height="50"
                  src="/static/img/landing/icon-14.png"
                  class="image wp-image-1200  attachment-full size-full"
                  alt=""
                  loading="lazy"
                  style="max-width: 100%; height: auto;"
                />
              </a>
            </span>
          </span>
        </div>
        <span
          class="-center-wrapper js-footer-lobby-selector js-menu-mobile-container"
        >
          <a
            href="javascript:void(0)"
            class="centerMobileMenu"
            @click="gotoRoute('/')"
          >
            <div class="-selected">
              <img src="/static/img/logo/main_logo_20221004223046.png" />
            </div>
          </a>
        </span>
        <div class="-fake-center-bg-wrapper">
          <svg viewBox="-10 -1 30 12">
            <defs>
              <linearGradient
                id="rectangleGradient"
                x1="0%"
                y1="0%"
                x2="0%"
                y2="100%"
              >
                <stop offset="0%" stop-color="rgb(252, 239, 205)"></stop>
                <stop offset="100%" stop-color="rgb(221, 212, 188)"></stop>
              </linearGradient>
            </defs>
            <path
              d="M-10 -1 H30 V12 H-10z M 5 5 m -5, 0 a 5,5 0 1,0 10,0 a 5,5 0 1,0 -10,0z"
            ></path>
          </svg>
        </div>
        <div class="-right-wrapper">
          <span class="-item-wrapper">
            <span class="-ic-img">
              <a
                href="javascript:void(0)"
                @click="gotoRoute('/user/promotion')"
              >
                <span class="-textfooter d-block">
                  โปรโมชั่น
                </span>
                <img
                  width="100"
                  height="100"
                  src="/static/img/landing/icon-6.png"
                  class="image wp-image-877  attachment-full size-full"
                  alt=""
                  loading="lazy"
                  style="max-width: 100%; height: auto;"
                />
              </a>
            </span>
          </span>
          <span class="-item-wrapper">
            <span class="-ic-img">
              <a
                v-bind:href="`https://line.me/R/ti/p/${getLineId}`"
                target="_blank"
              >
                <span class="-textfooter d-block">
                  ติดต่อเรา
                </span>
                <img
                  width="150"
                  height="150"
                  src="/static/img/landing/icon-13.png"
                  class="image wp-image-876  attachment-full size-full"
                  alt=""
                  loading="lazy"
                  style="max-width: 100%; height: auto;"
                />
              </a>
            </span>
          </span>
        </div>
        <div class="-fully-overlay js-footer-lobby-overlay"></div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import { UserInfoMixins } from "@/mixins/UserInfo.js";

export default {
  name: "Header",
  data() {
    return {
      isShowNav: true,
      toggle: true,

      nowPage: this.$route.name,
    };
  },
  watch: {
    $route() {
      this.isShowNav = true;
      this.nowPage = this.$route.name;
      if (
        this.$route.name == "Login" ||
        this.$route.name == "Signup" ||
        this.$route.name == "Profile" ||
        this.$route.name == "Join"
      ) {
        return (this.isShowNav = false);
      }
    },
  },
  mixins: [UserInfoMixins],
  methods: {
    ...mapActions(["userSignOut", "appTitle"]),
    gotoRouteGame(route) {
      this.$router.push({ path: route }).catch(() => {});
    },
    gotoRouteMobile(route) {
      var myCollapse = document.getElementById("navbarSupportedContent");
      console.log(myCollapse.classList.contains("show"));
      if (myCollapse.classList.contains("show")) {
        var bsCollapse = new bootstrap.Collapse(myCollapse);
        bsCollapse.hide();
      }
      this.$router.push(route).catch(() => {});
    },
    gotoRoute(route) {
      this.$router.push(route).catch(() => {});
    },
    getPageActive(page) {
      if (this.nowPage == page) {
        return "menu-item menu-item-type-custom menu-item-object-custom current-menu-item current_page_item menu-item-home menu-item-9";
      }
    },
    async SignOut() {
      await this.userSignOut();
    },
  },
  computed: {
    ...mapGetters(["getLineId"]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/layout/Header.vue